__turbopack_context__.v({
  "empty": "page-module__n5O0Ma__empty",
  "emptyIcon": "page-module__n5O0Ma__emptyIcon",
  "emptyText": "page-module__n5O0Ma__emptyText",
  "emptyTitle": "page-module__n5O0Ma__emptyTitle",
  "groupHead": "page-module__n5O0Ma__groupHead",
  "groupName": "page-module__n5O0Ma__groupName",
  "groupNote": "page-module__n5O0Ma__groupNote",
  "page": "page-module__n5O0Ma__page",
  "results": "page-module__n5O0Ma__results",
  "searchPage": "page-module__n5O0Ma__searchPage",
  "tripHead": "page-module__n5O0Ma__tripHead",
  "tripMeta": "page-module__n5O0Ma__tripMeta",
  "tripTitle": "page-module__n5O0Ma__tripTitle",
});
